import { theme } from '@frontend/theme';
import { NumberField, useFormField } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  maxAge: number | undefined;
  maxAgeLabel: string;
  minAge: number | undefined;
  minAgeLabel: string;
  onChangeMaxAge: (value: number | undefined) => void;
  onChangeMinAge: (value: number | undefined) => void;
  resetKey: number;
};

export const AgeFilter = ({
  maxAge,
  maxAgeLabel,
  minAge,
  minAgeLabel,
  onChangeMaxAge,
  onChangeMinAge,
  resetKey,
}: Props) => {
  const { trackingIdPrefix } = useAudienceTray();
  const minTrackingId = `${minAgeLabel.toLowerCase().split(' ').join('-')}-filter-input`;
  const maxTrackingId = `${maxAgeLabel.toLowerCase().split(' ').join('-')}-filter-input`;

  // TODO: Add validation so the minimum is always less than the maximum
  const minAgeField = useFormField({ type: 'number', min: 0, max: 99, value: minAge?.toString() }, [resetKey]);
  const maxAgeField = useFormField({ type: 'number', min: 0, max: 99, value: maxAge?.toString() }, [resetKey]);

  return (
    <div
      css={{
        display: 'grid',
        gap: theme.spacing(2),
        gridTemplateColumns: 'auto auto',
      }}
    >
      <NumberField
        {...minAgeField}
        name='minimum-age'
        onChange={(e) => {
          minAgeField.onChange(e);
          // @ts-expect-error - Types for form field events are not accurate
          const minValue = e?.value;
          onChangeMinAge(minValue ? +minValue : undefined);
        }}
        label={minAgeLabel}
        data-trackingid={`${trackingIdPrefix}-${minTrackingId}`}
      />
      <NumberField
        {...maxAgeField}
        name='maximum-age'
        onChange={(e) => {
          maxAgeField.onChange(e);
          // @ts-expect-error - Types for form field events are not accurate
          const maxValue = e?.value;
          onChangeMaxAge(maxValue ? +maxValue : undefined);
        }}
        label={maxAgeLabel}
        data-trackingid={`${trackingIdPrefix}-${maxTrackingId}`}
      />
    </div>
  );
};
